import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SrTourListRowEditButton extends Component {
  static propTypes = {
    tour: PropTypes.object.isRequired,
    onClickEdit: PropTypes.func.isRequired,
    onConfirmSaveLastListing: PropTypes.func.isRequired,
  };

  render() {
    const { tour, onClickEdit, onConfirmSaveLastListing } = this.props;

    const isSingleListing = tour.listings.length === 1;

    return (
      <span className="edit" onClick={isSingleListing ? onConfirmSaveLastListing : onClickEdit}>
        {isSingleListing ? 'Cancel' : 'Edit'}
      </span>
    );
  }
}

SrTourListRowEditButton.displayName = 'SrTourListRowEditButton';

export default SrTourListRowEditButton;
